import { render } from "./Create.vue?vue&type=template&id=18000088&bindings={\"errors\":\"props\",\"form\":\"data\",\"create\":\"options\"}"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "18000088"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('18000088')) {
    api.reload('18000088', script)
  }
  
  module.hot.accept("./Create.vue?vue&type=template&id=18000088&bindings={\"errors\":\"props\",\"form\":\"data\",\"create\":\"options\"}", () => {
    api.rerender('18000088', render)
  })

}

script.__file = "resources/js/Pages/Courses/Create.vue"

export default script